import { gql } from '@apollo/client';

import { OptionFragment } from './Option';
import { AppFragment } from './App';

export const ProductFragment = gql`
  fragment ProductFragment on Product {
    mmId
    posId
    imageUri
    description
    name
    customPosId
    variablesByApp {
      app {
        ...AppFragment
      }
      price
      availability
      snoozedUntil
      surcharge {
        amount
        type
      }
      imageUri
    }
    tags
    dietary
    options {
      ...OptionFragment
    }
  }

  ${AppFragment}
  ${OptionFragment}
`;
export const SetProductAvailabilityMutation = gql`
  mutation SetProductAvailability(
    $posId: String!
    $locationId: String!
    $isAvailable: Boolean!
    $productIsVariantInApps: [String!]!
    $wasProductPreviouslySnoozed: Boolean!
  ) {
    setProductAvailability(
      posId: $posId
      locationId: $locationId
      isAvailable: $isAvailable
      productIsVariantInApps: $productIsVariantInApps
      wasProductPreviouslySnoozed: $wasProductPreviouslySnoozed
    ) {
      ...ProductFragment
    }
  }

  ${ProductFragment}
`;

export const ScheduleProductUpdateFragment = gql`
  fragment ScheduleProductUpdateFragment on ScheduleProductUpdateMutation {
    id
    description
    enabled
    request {
      method
      path
      payload
      headers
    }
    cron
    onceAt
    createdAt
    updatedAt
  }
`;

export const SnoozeProductOnceAtMutation = gql`
  mutation SnoozeProductOnceAt(
    $locationId: String!
    $posId: String!
    $onceAt: String!
    $productIsVariantInApps: [String!]!
  ) {
    snoozeProductOnceAt(
      locationId: $locationId
      posId: $posId
      onceAt: $onceAt
      productIsVariantInApps: $productIsVariantInApps
    ) {
      ...ScheduleProductUpdateFragment
    }
  }

  ${ScheduleProductUpdateFragment}
`;

export const UpdateProductMutation = gql`
  mutation UpdateProduct($product: ProductInput!, $locationId: String!) {
    updateProduct(product: $product, locationId: $locationId) {
      failedApps
      product {
        ...ProductFragment
      }
    }
  }

  ${ProductFragment}
`;

export const ProductLinkQuery = gql`
  query productLink($locationId: String!, $posId: String!, $appId: String!) {
    productLink(locationId: $locationId, posId: $posId, appId: $appId) {
      posId
      options {
        posId
        source
      }
    }
  }
`;

export const ProductLinksQuery = gql`
  query productLinks($locationId: String!, $posId: String!, $appIds: [String!]!) {
    productLinks(locationId: $locationId, posId: $posId, appIds: $appIds) {
      posId
      options {
        posId
        source
      }
      unitPrice
      appId
    }
  }
`;

export const UpdateProductImageMutation = gql`
  mutation updateProductImage(
    $posId: String!
    $image: DocumentUploadInput!
    $locationId: String!
    $appIds: [String!]!
  ) {
    updateProductImage(posId: $posId, image: $image, appIds: $appIds, locationId: $locationId) {
      newImageUrl
      failedAppIds
    }
  }
`;

export const DeleteProductImageMutation = gql`
  mutation deleteProductImage($posId: String!, $locationId: String!, $appIds: [String!]!) {
    deleteProductImage(posId: $posId, appIds: $appIds, locationId: $locationId) {
      failedAppIds
    }
  }
`;

export const posProductsQuery = gql`
  query posProducts($locationId: String!, $searchTerm: String!, $offset: Int, $limit: Int) {
    posProducts(locationId: $locationId, searchTerm: $searchTerm, offset: $offset, limit: $limit) {
      items {
        posId
        imageUri
        description
        name
        unitPrice
        availability
        tags
        dietary
        customPosId
        options {
          name
          posId
          min
          max
          variants {
            name
            price
            posId
          }
        }
      }
      limit
      offset
      count
    }
  }
`;
export const posProductQuery = gql`
  query posProduct($locationId: String!, $posId: String!) {
    posProduct(locationId: $locationId, posId: $posId) {
      posId
      name
      type
      customPosId
      description
      tags
      dietary
      options {
        name
        posId
        min
        max
        variants {
          name
          price
          posId
        }
      }
      imageUri
      availability
      unitPrice
    }
  }
`;

export const PosProductPrice = gql`
  query posProductPrice($locationId: String!, $posId: String!) {
    posProduct(locationId: $locationId, posId: $posId) {
      posId
      unitPrice
    }
  }
`;
